import axios from '@/axios/'

const actions = {
  getCanJtkSeatChange(_, param) {
    return axios.post('/GetCanJtkSeatChange/1.0/', param)
  }
}

export default {
  namespaced: true,
  actions,
}
